export default "__VITE_ASSET__382487db__"